import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const streamDescriptionContainer = style([
  {
    marginBottom: space.s16,
  },
]);

export const descriptionContent = style([
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const showMoreDescription = style({
  marginTop: space.s8,
});
